import PropTypes from 'prop-types'

import { ROUTES } from './../../actions/routing'
import { AGENT_TYPE } from './../../actions/agent'

const stateProps = {
  'router.current': PropTypes.string.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  router: { current: currentRoute },
}) => {
  return (currentRoute === ROUTES.ROUTE_TO_DISCONNECT)
}
/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({
  state: {
    agent: { type: agentType },
    disconnect: {
      disconnectMessage,
    }
  },
  translate,
}) => {
  let iconClass = 'modal-icon-ondemand-disconnected'
  let title = 'title-disconnected'
  let hasParentWindow = false
  try {
    hasParentWindow = Boolean(window.opener)
  } catch (_) {
    hasParentWindow = false
  }

  const onClose = () => {
    window.close()
  }

  const buttons = (hasParentWindow)
    ? [
      {
        text: 'btn-close-tab',
        onClick: onClose,
        tooltip: hasParentWindow ? null : 'tooltip-close-browser-tab',
        disabled: !hasParentWindow,
      }
    ]
    : null

  const closeTabTextKey = `disconnect-close-tab${agentType === AGENT_TYPE.CLASSROOM_AGENT ? '-classroom' : ''}`
  // return modal data
  return {
    iconClass,
    title,
    body: `${translate(disconnectMessage)}${hasParentWindow ? translate(closeTabTextKey) : ''}`,
    buttons,
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
